
export const exceptionsRoutes = [
  {
    path: '/400',
    name: '400',
    component: () => import('@domains/exceptions/views/exception.view.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@domains/exceptions/views/exception.view.vue')
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@domains/exceptions/views/exception.view.vue')
  },

];
